/**
 * Points de commande / kiosque QR (parité legacy A8/C10 — ORDER_POINTS).
 * Un QR collé sur une table / au comptoir ouvre le site avec `?point=table-3`.
 * Le point est capturé puis joint à la commande (colonne `orders.order_point`)
 * et imprimé sur le ticket cuisine. Logique PURE et testable.
 */

export interface OrderPoint {
  key: string;
  label: string;
}

/** Catalogue par défaut (porté du legacy : comptoir, tables, drive, entrée). */
export const DEFAULT_ORDER_POINTS: OrderPoint[] = [
  { key: 'comptoir', label: 'Comptoir' },
  { key: 'table-1', label: 'Table 1' },
  { key: 'table-2', label: 'Table 2' },
  { key: 'table-3', label: 'Table 3' },
  { key: 'table-4', label: 'Table 4' },
  { key: 'table-5', label: 'Table 5' },
  { key: 'table-6', label: 'Table 6' },
  { key: 'drive', label: 'Drive' },
  { key: 'entree', label: 'Entrée' },
];

/** Transforme une clé brute (`table-3`) en libellé lisible (`Table 3`). */
export function pointLabel(key: string, points: OrderPoint[] = DEFAULT_ORDER_POINTS): string {
  const found = points.find((p) => p.key === key.toLowerCase());
  if (found) return found.label;
  // Repli : `table-3` → `Table 3`, `zone_a` → `Zone A`.
  return key
    .replace(/[-_]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Lit le point de commande depuis une query string (`?point=table-3` ou `?p=...`).
 * Renvoie le libellé lisible, ou null si absent/vide. Borné à 40 caractères.
 */
export function parseOrderPoint(search: string): string | null {
  let qs = search ?? '';
  if (qs.startsWith('?')) qs = qs.slice(1);
  const params = new URLSearchParams(qs);
  const raw = (params.get('point') ?? params.get('p') ?? '').trim();
  if (!raw) return null;
  return pointLabel(raw).slice(0, 40);
}
